module.exports = __webpack_public_path__ + "static/pic1-18483d9c7a6ab25ccc51ba83f7546e49.jpg";